module.exports = __webpack_public_path__ + "static/img/Version_ICON.cb49a4ef.png";